// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2iYxy","select":"Header_select__2ihXR","clinic":"Header_clinic__lSENM"};